module.exports = __webpack_public_path__ + "img/mark_star_4_icon.38827173.png";